export const MyBookings = {
  en: {
    'No Data Provided': 'No Data Provided',
    'Date and Time Period': 'Date and Time Period',
    'Location Name': 'Location Name',
    'Booking Service Name': 'Booking Service Name',
    'Booking Provider Name': 'Booking Provider Name',
    Status: 'Status',
    'My Bookings': 'My Bookings',
    Of: 'of',
    'Rows Per Page': 'Rows Per Page',
  },
  uk: {
    'No Data Provided': 'Дані відсутні',
    'Date and Time Period': 'Дата та час',
    'Location Name': 'Локація',
    'Booking Service Name': 'Сервіс',
    'Booking Provider Name': 'Інструктор',
    Status: 'Статус',
    'My Bookings': 'Мої бронювання',
    Of: 'з',
    'Rows Per Page': 'Рядків на сторінці',
  },
};
